var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimIconLargeRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "70px",
    viewBox: "0 0 69 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Claim Icon / Rejected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Claim-Icon-/-Rejected",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFF0ED",
    x: 0,
    y: 0,
    width: 69,
    height: 70,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,56 C18.3431458,56 17,54.6568542 17,53 L17,17 C17,15.3431458 18.3431458,14 20,14 L48,14 C49.6568542,14 51,15.3431458 51,17 L51,53 C51,54.6568542 49.6568542,56 48,56 L20,56 Z M24,22 C23.4477153,22 23,22.4477153 23,23 C23,23.5522847 23.4477153,24 24,24 L32,24 C32.5522847,24 33,23.5522847 33,23 C33,22.4477153 32.5522847,22 32,22 L24,22 Z M24,38 C23.4477153,38 23,38.4477153 23,39 C23,39.5522847 23.4477153,40 24,40 L41,40 C41.5522847,40 42,39.5522847 42,39 C42,38.4477153 41.5522847,38 41,38 L24,38 Z M24,42 C23.4477153,42 23,42.4477153 23,43 C23,43.5522847 23.4477153,44 24,44 L44,44 C44.5522847,44 45,43.5522847 45,43 C45,42.4477153 44.5522847,42 44,42 L24,42 Z M24,46 C23.4477153,46 23,46.4477153 23,47 C23,47.5522847 23.4477153,48 24,48 L39,48 C39.5522847,48 40,47.5522847 40,47 C40,46.4477153 39.5522847,46 39,46 L24,46 Z",
    id: "Combined-Shape",
    fill: "#FF7E5E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(38.000000, 5.000000)",
    fill: "#FF6640"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 12,
    r: 12
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M51.3947266,16.9965768 L54.7010261,20.29506 C55.099658,20.7015082 55.099658,21.2955479 54.7010261,21.6941797 C54.2945779,22.1006279 53.7083546,22.1006279 53.3019064,21.701996 L50.0034232,18.3956965 L46.70494,21.701996 C46.2984918,22.1006279 45.7044521,22.1006279 45.3058203,21.6941797 C44.8993721,21.2955479 44.8993721,20.7015082 45.298004,20.29506 L48.6043035,16.9965768 L45.298004,13.6980936 C44.8993721,13.2916454 44.8993721,12.7054221 45.3058203,12.2989739 C45.7044521,11.900342 46.2984918,11.900342 46.70494,12.2989739 L50.0034232,15.6052734 L53.3019064,12.2989739 C53.7083546,11.900342 54.2945779,11.900342 54.7010261,12.2989739 C55.099658,12.7054221 55.099658,13.2916454 54.7010261,13.6980936 L51.3947266,16.9965768 Z",
    id: "d",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimIconLargeRejected);
export default __webpack_public_path__ + "static/media/claim-icon-large-rejected.ca37d15ce253417768502d9e8f9f40a0.svg";
export { ForwardRef as ReactComponent };